<template>
  <div class="text-center m-5" v-if="loading">
    <b-spinner variant="secondary" label="Loading..."></b-spinner>
  </div>
  <div v-else>
    <div class="container mb-5">
      <h1 class="mb-3">Rezultati tvojih poteškoća u donošenju karijernih odluka</h1>
      <p>
        Pred tobom su rezultati upitnika o poteškoćama u donošenju profesionalnih odluka.
        Na osnovu njih možeš videti sa kojim se poteškoćama suočavaš kada treba da doneseš odluku koja se tiče tvog obrazovanja ili budućeg zaposlenja.
      </p>
      <p>Boje na grafiku predstavljaju stepen tvojih poteškoća.</p>
      <p>
        Ukoliko je bar za određenu barijeru zelene boje, to ukazuje da imaš malo poteškoća u tom području.
        <br />Ukoliko je bar za određenu barijeru žute boje, preporučujemo ti da pročitaš opis poteškoće i savet kako da je uspešnije prevaziđeš.
        <br />Ukoliko je tvoj rezultat za određenu barijeru crvene boje, to ukazuje da se suočavaš sa dosta poteškoća u tom području. Preporučujemo ti da pročitaš opis i poslušaš savet.
      </p>

      <apexchart type="bar" :options="chartOptions" :series="series"></apexchart>
    </div>
    <div class="jumbotron jumbotron-fluid mb-5 text-dark">
      <div class="container" v-if="responses.length>0">
        <h2 class="mb-4">Tvoji odgovori odražavaju značajne poteškoće koje uključuju:</h2>
        <div
          v-for="response in $store.getters['test/getResponses']"
          :key="response.id"
          class="response-item"
        >
          <Response :response="response" />
        </div>
      </div>
      <div v-else class="container">
        <p class="lead">Nemaš poteškoća u procesu karijenog odlučivanja!</p>
      </div>
    </div>
    <Evaluate></Evaluate>
  </div>
</template>

<script>
import Response from "@/components/Response.vue";
import VueApexCharts from "vue-apexcharts";
import Evaluate from "@/components/Evaluate.vue";

export default {
  name: "Results",
  components: {
    Response,
    apexchart: VueApexCharts,
    Evaluate
  },
  data() {
    return {
      loading: false,
      results: this.$store.getters["test/getResults"],
      responses: [],
      series: [
        {
          name: "Ocena",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      chartOptions: {
        theme: {
          mode: "light"
        },
        tooltip:{
          enabled:false
        },
        chart: {
          background: "#e9ecef"
        },
        responsive: [
          {
            breakpoint: 991,
            options: {
              chart: {
                height: 500
              },
              dataLabels: {
                style: {
                  colors: ["#333"],
                  fontSize: "12px"
                }
              }
            }
          }
        ],
        colors: [
          function({ value, seriesIndex, w }) {
            if (value < 3) {
              return "#25976F";
            } else if (value >= 3 && value < 6) {
              return "#E5C100";
            } else {
              return "#db2323";
            }
          }
        ],
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom"
            }
          }
        },
        grid: {
          show: true,
          padding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            colors: ["#333"],
            fontSize: "14px"
          },
          formatter: function(val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: false
          }
        },
        xaxis: {
          label: {
            minHeight: 30,
            style: {
              color: "#ccc"
            }
          },
          max: 10,
          min: 0,
          categories: [
            "Nedostatak motivacije",
            "Opšta neodlučnost",
            "Pogrešna uverenja o donošenju karijernih odluka",
            "Nedostatak informacija o procesu donošenja odluka",
            "Nedovoljno jasna slika o sebi",
            "Nedostatak informacija o svetu rada",
            "Nepoznavanje načina prikupljanja informacija",
            "Nepouzdane informacije",
            "Unutrašnji konflikti",
            "Spoljašnji konflikti"
          ]
        },
        yaxis: {
          minHeight: 32,
          labels: {
            show: false
          }
        }
      }
    };
  },
  created() {
    this.loading = true;
    this.getResults();
    this.getResponses();
  },
  methods: {
    mapValues() {
      return Object.values(this.results).map(item => {
        return item.value;
      });
    },
    mapLabels() {
      return Object.values(this.results).map(item => {
        return item.label;
      });
    },
    getResults() {
      let vm = this;
      this.$store
        .dispatch("test/getResults")
        .then(() => {
          this.results = this.$store.getters["test/getResults"];
          //console.log(this.results);
          let newData = this.mapValues();
          this.series = [{ name: "Ocena", data: newData }];
          vm.loading = false;
        })
        .catch(err => {
          vm.error = true;
          vm.loading = false;
          console.log(err);
        });
    },
    getResponses() {
      let vm = this;
      this.$store
        .dispatch("test/getResponses")
        .then(() => {
          this.responses = this.$store.getters["test/getResponses"];
          //console.log(this.responses);
          vm.loading = false;
        })
        .catch(err => {
          vm.error = true;
          vm.loading = false;
          console.log(err);
        });
    }
  }
};
</script>

<style>
.apexcharts-tooltip {
  background: #f3f3f3;
  color: #333;
}
.response-item .title {
  font-weight: 600;
}
.apexcharts-menu.open{
  background: #485655;
}
.light .apexcharts-menu-item:hover{
  color:#555;
}
</style>